import router from "~/common/router";
import Top from "~/pages/static_pages/top";

router("static_pages", ["top"], () => {
  document.addEventListener("DOMContentLoaded", () => {
    Top.start();
  });
});
